export default "__VITE_ASSET__be684d9e__"